class NavController extends HTMLElement {
  constructor() {
    super();
    this.hamburgerMenuButton = null;
    this.navigation = null;
    this.navItems = null;
    this.orderButtons = null;
    this.navMenu = null;
    
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  connectedCallback() {
    this.hamburgerMenuButton = this.querySelector('[data-nav="menu-button"]');
    this.navigation = this.querySelector('[data-nav="container"]');
    this.navItems = this.querySelectorAll('[data-nav="menu-item"]');
    this.orderButtons = this.querySelectorAll('[data-nav="order-button"]');
    this.navMenu = this.querySelector('[data-nav="menu"]');

    if (!this.hamburgerMenuButton || !this.navigation || !this.navItems || !this.orderButtons || !this.navMenu) {
      console.error('NavController: Missing required elements');
      return;
    }

    this.setupEventListeners();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('click', this.handleClickOutside);
  }

  setupEventListeners() {
    this.hamburgerMenuButton?.addEventListener('click', (e) => {
      e.stopPropagation(); // prevent triggering  handleClickOutside
      this.navigation?.classList.toggle('open');
      this.hamburgerMenuButton?.classList.toggle('open');
    });

    this.navItems?.forEach(item => {
      item.addEventListener('click', () => {
        this.closeMenu();
      });
    });

    this.orderButtons?.forEach(button => {
      button.addEventListener('click', () => {
        this.closeMenu();
      });
    });

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    document.addEventListener('click', this.handleClickOutside);
  }

  handleScroll() {
    // Use requestAnimationFrame to throttle scroll events
    requestAnimationFrame(() => {
      if (this.navigation?.classList.contains('open')) {
        this.closeMenu();
      }
    });
  }

  handleClickOutside(event) {
    if (this.navigation?.classList.contains('open') && 
        !this.navMenu?.contains(event.target) && 
        event.target !== this.hamburgerMenuButton) {
      this.closeMenu();
    }
  }

  closeMenu() {
    this.navigation?.classList.remove('open');
    this.hamburgerMenuButton?.classList.remove('open');
  }
}

customElements.define('nav-controller', NavController); 